import { useEffect, useState } from 'react';

import { PageContent } from 'lib/confluence';
import { APP } from 'lib/strings';
import { Button, Icon, raulUtils } from 'lib/raul';
import TableOfContents from 'Article/TableOfContents';

interface Props {
  includeToc: boolean;
  pageContent: PageContent;
  pageElement: HTMLElement;
}

const DetailView = ({ includeToc, pageContent, pageElement }: Props) => {
  const [isHeaderInView, setIsHeaderInView] = useState(true);

  useEffect(() => {
    const checkPosition = () => {
      setIsHeaderInView(window.pageYOffset < 140);
    };

    window.addEventListener('scroll', checkPosition);

    return () => window.removeEventListener('scroll', checkPosition);
  }, []);

  return (
    <div className="overflow-visible r-p-6 md:r-p-9 r-bg-white r-min-h-article r-border-b r-border-gray-light">
      {pageContent && (
        <>
          <h1 className="r-heading-hero r-hidden r-print-show">
            {pageContent.title}
          </h1>
          {!isHeaderInView && includeToc && (
            <div className="r-fixed r-right-0 r-bottom-0 r-pr-6 r-pb-6 md:r-pr-9 md:r-pb-9">
              <Button
                handleClick={raulUtils.handleOpenAside('contents')}
                variant="primary"
              >
                <Icon icon="list-bullets-3" />
              </Button>
            </div>
          )}
          {includeToc && (
            <TableOfContents article={pageElement} title={pageContent.title} />
          )}
          <div dangerouslySetInnerHTML={{ __html: pageContent.body }} />
          <p className="r-text-sm r-mb-5">{`${APP.LAST_UPDATED} ${pageContent.lastModifiedDate.friendly}`}</p>
        </>
      )}
    </div>
  );
};

export default DetailView;
